import { useQuery } from "@tanstack/react-query";
import { Role } from "@/model";
import roleRepository from "@/repository/roleRepository";


const getData = async (agentId: number) => {
    const res = await roleRepository.find(agentId);
    return res.data?.data;
};

export const useRole = (agentId: number) => {
    return useQuery<Role[]>({
        queryKey: ["role", "agent", agentId],
        queryFn: async () => getData(agentId),
        retry: false
    });
};
